import { BaseApi } from "../../../../services/base-api";
import { ENDPOINTS } from "./endpoint";

export interface GetMenuItemsPayload {
	roleId: number[];
	storeFrontId: number; // fixed to 2
}

export type GetMenuItemsResponse = any;

export const getMenuItems = async (
	roleIds: number[]
): Promise<GetMenuItemsResponse> => {
	try {
		const payload: GetMenuItemsPayload = {
			roleId: roleIds,
			storeFrontId: 2,
		};
		const response = await BaseApi.customerBaseUrl.post(ENDPOINTS.menuItems, payload);
		return response?.data?.data;
	} catch (error: any) {
		throw new Error(error?.response?.data?.errorMessage || error.message);
	}
};
